import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091cdab3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#eceff7"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart3",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1))
const _hoisted_3 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_4 = { style: { width: '100%', height: '260px', backgroundColor: 'white' } }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"large","font-weight":"bold"} }, "通话频次数据", -1))
const _hoisted_6 = { style: {"padding":"0 20px"} }
const _hoisted_7 = {
  style: {"background":"linear-gradient(90deg, rgba(84, 112, 198, 1), rgba(84, 112, 198, 0.5))"},
  class: "cf-box"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf-txt" }, "1次:", -1))
const _hoisted_9 = { class: "cf-val" }
const _hoisted_10 = {
  style: {"background":"linear-gradient(90deg, rgba(238, 102, 102, 1), rgba(238, 102, 102, 0.5))"},
  class: "cf-box"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf-txt" }, "1次及以上:", -1))
const _hoisted_12 = { class: "cf-val" }
const _hoisted_13 = {
  style: {"background":"linear-gradient(90deg,rgba(145, 204, 117, 1), rgba(145, 204, 117, 0.5))"},
  class: "cf-box"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf-txt" }, "2次及以上:", -1))
const _hoisted_15 = { class: "cf-val" }
const _hoisted_16 = {
  style: {"background":"linear-gradient(90deg, rgba(250, 200, 88, 1), rgba(250, 200, 88, 0.5))"},
  class: "cf-box"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf-txt" }, "3次及以上:", -1))
const _hoisted_18 = { class: "cf-val" }
const _hoisted_19 = {
  style: {"background":"linear-gradient(90deg, rgba(144, 147, 153, 1), rgba(144, 147, 153, 0.5))"},
  class: "cf-box"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cf-txt" }, "5次及以上:", -1))
const _hoisted_21 = { class: "cf-val" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart6",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1))

import { onMounted, ref } from 'vue'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import localCache from '@/utils/cache'
import { ElLoading } from 'element-plus'
import type { FormInstance } from 'element-plus'
import * as echarts from 'echarts'
import {
  getTelephoneFrequency,
  getActivateData
} from '@/service/main/inspect/ResourceAnalysis'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePhoneActivate',
  setup(__props) {

const store = useStore()
const shortcuts = [
  {
    text: '最近7天',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      return [start, end]
    }
  },
  {
    text: '最近1个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      return [start, end]
    }
  },
  {
    text: '最近3个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 3)
      return [start, end]
    }
  }
]

const formRef = ref<FormInstance>(null);
const queryParam = ref({
  timeSlot: ref<[string, string]>([
    dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ]),
  deptId: ref(''),
  empName: ref('')
})

const handleResetClick = () => {
  queryParam.value = {
    timeSlot: [
      dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    deptId: '',
    empName: ''
  };
}

const resourceCount = ref(0)
const eq1CallNum = ref(0)
const ge1CallNum = ref(0)
const ge2CallNum = ref(0)
const ge3CallNum = ref(0)
const ge5CallNum = ref(0)
let myChart3 = null;
let myChart6 = null;
const option3 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },

  title: {
    text: '电话频次',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '1次'
        },
        {
          value: 0,
          name: '1次及以上'
        },
        {
          value: 0,
          name: '2次及以上'
        },
        {
          value: 0,
          name: '3次及以上'
        },
        {
          value: 0,
          name: '5次及以上'
        }
      ],
      radius: '75%',
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: '{b}:{d}%' // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}
const option6 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },
  title: {
    text: '激活客户数',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '激活客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: '{b}: {c}' // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}

const initData = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const [data2, data6] = await Promise.allSettled([
    getTelephoneFrequency(queryParam.value),
    getActivateData(queryParam.value)
  ])
  loadingInstance.close()
  if (data2.status == 'fulfilled') { // 确保图表已初始化
    eq1CallNum.value = data2.value.eq1CallNum
    ge1CallNum.value = data2.value.ge1CallNum
    ge2CallNum.value = data2.value.ge2CallNum
    ge3CallNum.value = data2.value.ge3CallNum
    ge5CallNum.value = data2.value.ge5CallNum
    if (myChart3) { // 确保图表已初始化
      myChart3.setOption({ // 更新图表配置项中的数据部分
        series: [{ data: [{ value: data2.value.eq1CallNum, name: '1次' }, { value: data2.value.ge1CallNum, name: '1次及以上' }, { value: data2.value.ge2CallNum, name: '2次及以上' }, { value: data2.value.ge3CallNum, name: '3次及以上' }, { value: data2.value.ge5CallNum, name: '5次及以上' }] }]
      });
    }
  } else {
    eq1CallNum.value = 0
    ge1CallNum.value = 0
    ge2CallNum.value = 0
    ge3CallNum.value = 0
    ge5CallNum.value = 0
    if (myChart3) {
      myChart3.setOption(option3)
    }
  }
  if (data6.status == 'fulfilled') {
    resourceCount.value = data6.value.resourceCount
    if (myChart6) {
      myChart6.setOption({ // 更新图表配置项中的数据部分
        title: { text: '激活客户数' + data6.value.activateCustNum },
        series: [{ data: [{ value: data6.value.activateCustNum, name: '激活客户数' }, { value: data6.value.resourceCount - data6.value.activateCustNum, name: '其他' }] }]
      });
    }
  } else {
    if (myChart6) {
      myChart6.setOption(option6)
    }
  }
}

const onSubmit = async (formRef: FormInstance) => {
  if (!formRef) return
  await formRef.validate((valid, fields) => {
    if (valid) {
      console.log('校验成功')
      initData()
    } else {
      console.log('校验失败')
    }
  })
}

onMounted(() => {
  initData()
  myChart3 = echarts.init(document.getElementById('myChart3'))
  myChart3.setOption(option3)
  myChart6 = echarts.init(document.getElementById('myChart6'))
  myChart6.setOption(option6)
  window.addEventListener('resize', function () {
    myChart3.resize();
  });
  window.addEventListener('resize', function () {
    myChart6.resize();
  });
})
const rules = {
  timeSlot: [{
    required: true,
    message: '加入时间必填',
    trigger: 'change',
  }],
}

const userOptions = localCache.getCache('empData').map((item: any) => {
  return { title: item.realName, value: item.realName }
})

const deptOptions = store.state.login.depts.map((item: any) => {
  return { title: item.name, value: item.id }
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      inline: true,
      model: queryParam.value,
      class: "demo-form-inline",
      rules: rules,
      style: {"padding":"10px 0 0","background-color":"#fff"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "组别" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryParam.value.deptId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParam.value.deptId) = $event)),
                      placeholder: "请选择组别",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deptOptions), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.title,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      onClick: handleResetClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit(formRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 7 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(84, 112, 198, 1), rgba(84, 112, 198, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("资源总数"),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(resourceCount.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(eq1CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, _toDisplayString(ge1CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, _toDisplayString(ge2CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(ge3CallNum.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(ge5CallNum.value), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})